export default {
  confirmDelete: {
    header: 'Odstrániť parameter "{parameter}" zariadenia "{asset}"?',
    message: 'Namiesto neho platí hodnota najbližšieho nadradeného zariadenia, alebo predvolená hodnota, ak ju žiadne nedefinuje.',
  },
};
